var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPlayAudio = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 30,
  height: 30,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 15,
  fill: "#3B5A7A"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.5 14.134a1 1 0 0 1 0 1.732l-7.392 4.268a1 1 0 0 1-1.5-.866v-8.536a1 1 0 0 1 1.5-.866l7.392 4.268Z",
  fill: "#fff"
})));
export default SvgPlayAudio;